import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import qs from 'qs';

import RedirectToHelpAndSupport from './Errors/RedirectToHelpAndSupport';
import XfiPodReturn from './Returns/XfiPodReturn';

import { loadReturns } from '../actions/returns';
import { getHasShippedLabel } from '../helpers/returns';
import { getHasXfiPods } from '../helpers/order';
import { flagEnabled } from '../helpers/featureFlags';
import { RETURNS_ORDER_STATUS, RETURNS_SELECT_DEVICE } from '../helpers/routes';
import LoadingWrapper from '../components/LoadingWrapper';
import GenericError from './Errors/GenericError';

class ReturnsHome extends Component {
  componentDidMount() {
    const { handleLoadDsmToken } = this.props;
    handleLoadDsmToken();
  }

  render() {
    const {
      returns,
      loading,
      isXfiPods,
      hasUnshippedXfiPods,
      submitError,
    } = this.props;

    if (loading) {
      return <LoadingWrapper />;
    }

    if (submitError) {
      return <GenericError />;
    }
    // Redirect to the status page if the customer already has unshipped Xfi Pods,
    // unless it was just initiated
    if (isXfiPods && hasUnshippedXfiPods && !hasUnshippedXfiPods.initiatedXfiPodReturn) {
      return <Redirect to={`/returns/status/${hasUnshippedXfiPods.returnOrderId}`} />;
    }

    // send to xfi pod component to submit the pod return
    if (isXfiPods) {
      return <XfiPodReturn />;
    }

    if (returns.length) {
      return <Redirect to={RETURNS_ORDER_STATUS} />;
    }

    if (flagEnabled('device-returns.disableOrders')) {
      return <RedirectToHelpAndSupport />;
    }

    return <Redirect to={RETURNS_SELECT_DEVICE} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    returns: { loading, returns },
    order: { submitError },
  } = state;

  const {
    location: { search },
  } = ownProps;

  const isXfiPods = qs.parse(search.replace(/^\?/, '')).type === 'xfi-pods';
  const hasUnshippedXfiPods = (
    returns.length
    && returns.find(({ returnInitiation }) => {
      const {
        devices = [],
        shippingLabels = [],
      } = returnInitiation;

      const hasXfiPods = getHasXfiPods(devices);
      const hasShippedLabel = getHasShippedLabel(shippingLabels);

      return hasXfiPods && !hasShippedLabel;
    })
  );

  return {
    returns,
    loading,
    isXfiPods,
    hasUnshippedXfiPods,
    submitError,
  };
};

const mapDispatchToProps = dispatch => ({
  handleLoadDsmToken: bindActionCreators(loadReturns, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsHome);
